import React from "react";
import { SimpleBarChart } from "@carbon/charts-react";
import "@carbon/charts/styles.css";
import { AGE_GROUPS, toNumber } from "./DashboardInsights";

const StackedBarChartByAge = ({ dashboardData }) => {
  const chartData = AGE_GROUPS.map(group => ({
    group: "Cases",
    key: group.label,
    value: toNumber(dashboardData?.[group.key]),
  }));

  const chartOptions = {
    axes: {
      left: {
        mapsTo: "key",
        scaleType: "labels",
      },
      bottom: {
        mapsTo: "value",
      },
    },
    color: {
      scale: {
        Cases: "#0f766e",
      },
    },
    legend: {
      enabled: false,
    },
    toolbar: {
      enabled: false,
    },
    resizable: true,
    height: "320px",
  };

  return <SimpleBarChart data={chartData} options={chartOptions} />;
};

export default StackedBarChartByAge;
